/* Initial Phoneme Segmentation audio */
import questionsInstruction from '../sounds/ips_avatar_general.mp3';
import questionsInstructionGeneral from '../sounds/ips_avatar_general_word.mp3';
import practiceInstruction from '../sounds/ips_practice_instruction.mp3';
import practiceInstructionStart from '../sounds/ips_practice_instruction_start.mp3';
import practiceInstructionReadyState from '../sounds/ips_practice_ready_instruction.mp3';

const IPS_AUDIO_INSTRUCTIONS = {
    questionsInstruction,
    questionsInstructionGeneral,
    practiceInstruction,
    practiceInstructionStart,
    practiceInstructionReadyState,
};

export default IPS_AUDIO_INSTRUCTIONS;
